import { render, staticRenderFns } from "./BEditorContent.vue?vue&type=template&id=a4e9762e&"
import script from "./BEditorContent.vue?vue&type=script&lang=js&"
export * from "./BEditorContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports